module.exports = __webpack_public_path__ + "img/img140.cc20329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/img140.jpg
// module id = 1768
// module chunks = 1